import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface ArticleSearchResult {
  uuid: string;
  title: string;
  body: string;
  thumbnail: string;
  is_enabled: boolean;
  created_at?: string | number;
  publication_date?: string | number;
}

@Injectable({ providedIn: 'root' })
export class ArticleSearchService {
  constructor(private http: HttpClient) {}

  searchArticles(query: string): Observable<{ results: ArticleSearchResult[] }> {
    const url = `${environment.apiUrl}/typesense/articles/search`;
    return this.http.get<{ results: ArticleSearchResult[] }>(url, { 
      params: { query, limit: '3' },
      headers: { Domain: localStorage.getItem('domain') || '' }
    });
  }
}
